
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { LocationDetailDto_$reflection } from "../../Shared/Location.js";
import { ClientApiResponse$1_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { union_type, string_type, class_type, record_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(Location) {
        super();
        this.Location = Location;
    }
}

export function State_$reflection() {
    return record_type("Location.Detail.Types.State", [], State, () => [["Location", RequestedValue$1_$reflection(LocationDetailDto_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DeleteLocation", "LocationFetched", "FetchError", "LocationDeleted"];
    }
}

export function Msg_$reflection() {
    return union_type("Location.Detail.Types.Msg", [], Msg, () => [[], [["Item", LocationDetailDto_$reflection()]], [["Item", class_type("System.Exception")]], [["Item", ClientApiResponse$1_$reflection(string_type)]]]);
}

